export default class State {
  items = []
  item = null
  pagination = {}
  model = ''

  constructor(model) {
    this.model = model
  }
}
